<!--
  Root row. Rendered only when the host passes `rootLabel`, because
  only the Move dialogs have a meaningful name for the top level
  ("My Projects"). Without it there is no way to select the root:
  the tree below lists its CHILDREN.
-->
<div class="tree-root-row" *ngIf="rootLabel">
  <span class="node-label tree-root-label"
        [class.active]="rootActive"
        [class.disabled]="disable(rootNode)"
        (click)="selectRoot()">
    <mat-icon class="tree-root-icon">home</mat-icon>{{rootLabel}}
  </span>
</div>

<!-- No folders exist yet — say so rather than showing an empty box. -->
<div class="tree-empty" *ngIf="!hasNodes && emptyMessage">{{emptyMessage}}</div>

<!--
  Expand / Collapse.

  The tree now opens itself to a useful depth (see `tree-expansion.ts`), and
  these are the escape hatches for when that guess is not the one this
  operator wanted. Only drawn when something can actually be collapsed.

  `type="button"` is load bearing: both Move dialogs put the tree inside a
  <form>, where a bare <button> defaults to submit.
-->
<div class="tree-toolbar" *ngIf="hasCollapsibleNodes">
  <button mat-icon-button type="button" class="tree-toolbar-btn" [disabled]="fullyExpanded"
          (click)="expandAll()" title="Expand" i18n-title="@@Expand">
    <mat-icon>unfold_more</mat-icon>
  </button>
  <button mat-icon-button type="button" class="tree-toolbar-btn"
          (click)="collapseToTopLevel()" title="Collapse" i18n-title="@@Collapse">
    <mat-icon>unfold_less</mat-icon>
  </button>
</div>

<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="reusable-tree">

  <!--
    `tree-row-hidden` on the synthetic root: it has no name, so its row was a
    blank line with a chevron, and opening it was a mandatory first click on
    every visit. It is expanded from the start now and its row is gone; the
    `.tree-root-row` above is the selectable root.
  -->
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [class.tree-row-hidden]="isSyntheticRoot(node)">
    <button mat-icon-button disabled></button>
    <span class="node-label" [class.active]="isActive(node)" (click)="selectNode(node)" [class.disabled]="disable(node)">
      {{node.name}}
    </span>
  </mat-tree-node>

  <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
    <div class="mat-tree-node" [class.tree-row-hidden]="isSyntheticRoot(node)">
      <button mat-icon-button matTreeNodeToggle>
        <mat-icon>{{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}</mat-icon>
      </button>
      <span class="node-label" [class.active]="isActive(node)" (click)="selectNode(node)" [class.disabled]="disable(node)">
        {{node.name}}
      </span>
    </div>
    <!--
      The synthetic root's group carries no indent guide: its row is hidden,
      so a guide line there would hang off nothing and push every real folder
      in by a level that does not exist.
    -->
    <div [class.tree-invisible]="!treeControl.isExpanded(node)"
         [class.tree-root-group]="isSyntheticRoot(node)" role="group">
      <ng-container matTreeNodeOutlet></ng-container>
    </div>
  </mat-nested-tree-node>
</mat-tree>
